<template>
  <div class="detail">
    <el-card class="appoCard">
      <!-- <el-page-header @back="goBack" :content="tabName"></el-page-header> -->
      <div class="tab">
        <el-tabs style="width:100%">
          <el-tab-pane style="width:100%">
            <span slot="label" class="el-icon-date">
              <i></i>
              {{ tabName }}
            </span>
            <div class="main">
              <div class="searchBox">
                <div class="searchList mainItem">
                  <el-select
                    v-model="status"
                    placeholder="请选择"
                    @change="optChange"
                  >
                    <el-option
                      v-for="item in options"
                      :key="item.status"
                      :label="item.label"
                      :value="item.status"
                    ></el-option>
                  </el-select>
                </div>
                <div class=" mainItem">
                  <el-date-picker
                    style="width: 100%"
                    v-model="time"
                    type="datetimerange"
                    align="center"
                    unlink-panels
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :picker-options="pickerOptions"
                    value-format="yyyy-MM-dd"
                    @change="optChange"
                  >
                  </el-date-picker>
                </div>
                <div class="searchInput mainItem">
                  <el-input
                    v-model="name"
                    placeholder="请输入患者姓名"
                    @keyup.native="nameChange"
                  ></el-input>
                </div>
                <div class="searchInput mainItem">
                  <el-button type="text" style="margin-left:50px" @click="empty"
                    >清空条件</el-button
                  >
                  <el-button class="searchInput_btn" @click="search"
                    >搜索</el-button
                  >
                </div>
              </div>
              <div class="content">
                <el-table :data="list_data" @sort-change="sortChange">
                  <el-table-column
                    align="center"
                    label="患者姓名"
                    prop="patientName"
                  ></el-table-column>
                  <el-table-column align="center" label="性别">
                    <template slot-scope="scope">
                      <div class="name-wrapper">
                        {{ PATIENT_GENDER[scope.row.patientGender] }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    align="center"
                    label="年龄"
                    prop="patientAge"
                  ></el-table-column>
                  <el-table-column align="center" label="创建时间">
                    <template slot-scope="scope">
                      <i class="el-icon-time"></i>
                      <span style="margin-left: 10px">{{
                        scope.row.createTime
                      }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="预约时间">
                    <template slot-scope="scope">
                      <i class="el-icon-time"></i>
                      <span style="margin-left: 10px"
                        >{{ scope.row.scheduleDate }}
                        {{ scope.row.schedulePeriodStart }}-{{
                          scope.row.schedulePeriodEnd
                        }}</span
                      >
                    </template>
                  </el-table-column>
                  <el-table-column
                    align="center"
                    label="预约状态/操作"
                    width="200px"
                  >
                    <template slot-scope="scope">
                      <el-tag>{{ ORDER_STATUS[scope.row.status] }}</el-tag>
                    </template>
                  </el-table-column>
                  <!--                  屏蔽这个入口。会和工作台的预约判断有冲突-->
                  <!--<el-table-column align="center" label="操作">
                    <template slot-scope="scope">
                      <el-button
                        size="mini"
                        type="danger"
                        @click="handleDetail(scope.$index, scope.row)"
                      >查看详情</el-button>
                    </template>
                  </el-table-column>-->
                </el-table>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="pageWarpper" v-show="list_data != ''">
        <el-pagination
          @current-change="currentPageChange"
          :page-size="pageList.size"
          :current-page="pageList.current"
          layout="total, prev, pager, next"
          :total="pageList.total"
        ></el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
import util from "@/utils";
import { getOrderList, appointHande } from "@/api/index.js";
import { ORDER_TYPE, PATIENT_GENDER, ORDER_STATUS } from "@/utils/constants";

export default {
  data() {
    return {
      ORDER_STATUS,
      PATIENT_GENDER,
      list_data: [],
      tableData: [],
      pageList: {
        pageSize: 10,
        current: 1,
        total: 0,
      },
      statusList: ["待确认", "已确认", "已拒绝"],
      tabName: "",
      options: [
        {
          status: "",
          label: "全部",
        },
        {
          status: "0",
          label: "待确认",
        },
        {
          status: "1",
          label: "已确认",
        },
        {
          status: "-1",
          label: "已拒绝",
        },
      ],
      status: "",
      time: [],
      name: "",
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      value1: "",
      value2: "",
    };
  },
  methods: {
    empty() {
      this.status = "";
      this.pageList.current = 1;
      this.time = [];
      this.name = "";
      this.readyApointList();
    },
    async edit(item, type) {
      try {
        let data = {
          status: type,
          id: item.id,
        };
        let res = await appointHande(data);
        if (res.success) {
          this.$message({
            message: res.message,
            type: "success",
          });
          this.readyApointList();
        } else {
          this.$message({
            message: res.message,
            type: "error",
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
    search() {
      console.log("name", name);
      this.readyApointList();
    },
    //分页
    currentPageChange(page) {
      this.pageList.current = page;
      this.readyApointList();
    },
    //返回上一层
    // goBack () {
    //   const that = this;
    //   let tabNum = this.$route.query.tabNum;
    //   if (tabNum == 2) {
    //     that.$router.push({
    //       path: "/index/work/patients",
    //     });
    //   } else {
    //     that.$router.push({
    //       path: "/index/work/appointment",
    //     });
    //   }
    // },
    //阅片
    handleCheck(index, row) {
      let query = {
        sickId: row.im_accid,
        tabNum: this.$route.query.tabNum,
      };
      this.$router.push({
        path: "/index/work/slice",
        query,
      });
    },
    //查看详情
    handleDetail(index, row) {
      let query = {
        tabNum: this.$route.query.tabNum,
        fromType: "workdetail",
        sessionId: "p2p-" + row.im_accid,
        case_id: row.id,
      };
      if (row.id) {
        this.$router.push({
          path: "/index/work/patientDetails",
          query,
        });
      } else {
        this.$message({
          type: "error",
          message: "当前会话已删除",
        });
      }
    },
    sortChange(column, prop, order) {},
    //下拉列表选项改变
    optChange(val) {
      console.log(val);
      var tabNum = this.$route.query.tabNum;
      if (tabNum == "2") {
        this.readyPatientList();
      } else if (tabNum == "3") {
        this.readyApointList();
      }
    },
    //关键字输入框离开事件
    nameChange() {
      console.log("name: ", this.name);
    },
    //预约列表
    async readyApointList(index, row) {
      try {
        var that = this;
        let startTime;
        let endTime;
        if (that.time) {
          startTime = that.time[0];
          endTime = that.time[1];
        }
        let params = {
          status: that.status,
          startTime: startTime,
          endTime: endTime,
          current: that.pageList.current,
          size: that.pageList.pageSize,
          patientName: that.name,
          doctorId: util.getStore("user_id"),
        };
        let res = await getOrderList(params);
        if (res.code === 1) {
          this.list_data = res.data.records;
          this.pageList.total = Number(res.data.total);
          // this.pageList = res.result;
        }
      } catch (error) {
        console.log(error);
      }
    },
  },

  mounted() {
    var tabList = ["最近咨询", "我的患者", "我的预约"];
    var tabNum = this.$route.query.tabNum;
    this.tabName = tabList[tabNum - 1];
    if (tabNum == "2") {
      this.readyPatientList();
    } else if (tabNum == "3") {
      this.readyApointList();
    }
  },
};
</script>

<style lang="scss" scoped>
.el-page-header {
  margin-top: 20px;
}

/deep/ .el-table__empty-text {
  color: #cfcbc9 !important;
  font-weight: bold;
  font-size: 18px;
  padding-top: 200px;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background-repeat: no-repeat;
  background-position: center !important;
}

.detail {
  padding: 20px;
  width: 95%;
  // min-width: 1250px;
  .appoCard {
    width: 100%;
    min-height: 900px;
  }
  /*  .mainItem {
    float: left;
  }

  .mainItem:nth-child(2) {
    margin: 0 20px;
  }

  .mainItem:nth-child(3) {
    width: 20%;
  } */
  .pageWarpper {
    text-align: center;
  }
  .searchInput_btn {
    margin-left: 10%;
    height: 40px;
    width: 33%;
  }
}
.tab {
  width: 100%;
  display: flex;

  .main {
    flex: 1;
    display: flex;
    flex-direction: column;
    // align-items: center;
    .searchBox {
      display: flex;
      // flex-wrap: wrap;
      justify-content: space-between;
      .mainItem {
        flex: 1;
        margin-right: 30px;
      }

      .mainItem:nth-child(2) {
        flex: 4;
      }

      .mainItem:nth-child(3) {
        flex: 3;
      }
      .mainItem:last-child {
        flex: 3;
        margin-right: 0;
        display: flex;
        justify-content: space-around;
      }
    }
    .content {
      width: 100%;
    }
  }
}
.el-icon-date {
  color: #fc701a !important;
}

.footer .el-button {
  background: #ffffff;
  color: #fc701a;
  border-color: #fc701a;
}

.footer .el-button--primary,
.searchInput_btn {
  color: #ffffff !important;
  background: #fc701a !important;
  border-color: #fc701a;
}

.el-button--text {
  color: #fc701a;
}

.el-range-editor.is-active {
  border-color: #fc701a !important;
}

.el-select-dropdown__item.selected {
  color: #fc701a !important;
}
</style>
